import React from 'react';

interface SortableColumnHeaderProps {
    label: string;
    field: string;
    currentSortBy: string;
    currentSortOrder: string;
    onSort: (field: string) => void;
}

export default function SortableColumnHeader({
    label,
    field,
    currentSortBy,
    currentSortOrder,
    onSort,
}: SortableColumnHeaderProps) {
    const isActive = currentSortBy === field;

    const getSortIcon = () => {
        if (!isActive) return <span className="ml-1 text-gray-400 opacity-0 group-hover:opacity-100" aria-hidden="true">&#x25B2;</span>;
        return currentSortOrder === 'ASC'
            ? <span className="ml-1 text-blue-500" aria-hidden="true">&#x25B2;</span>
            : <span className="ml-1 text-blue-500" aria-hidden="true">&#x25BC;</span>;
    };

    return (
        <th
            className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            role="columnheader"
            aria-sort={isActive ? (currentSortOrder === 'ASC' ? 'ascending' : 'descending') : 'none'}
        >
            <button
                type="button"
                onClick={() => onSort(field)}
                className="inline-flex items-center gap-0.5 group cursor-pointer select-none bg-transparent border-none p-0 font-medium text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 rounded"
                aria-label={`Ordenar por ${label}`}
            >
                {label}
                {getSortIcon()}
            </button>
        </th>
    );
}
